"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPERTIES_CARD_TYPE = exports.GLOBAL_PROPERTIES_CARD_TYPE = exports.GLOBAL_PROPERTIES_CARD_ID = exports.RIGHT_SIDEBAR = exports.LEFT_SIDEBAR = void 0;
var LEFT_SIDEBAR = 'LEFT_SIDEBAR';
exports.LEFT_SIDEBAR = LEFT_SIDEBAR;
var RIGHT_SIDEBAR = 'RIGHT_SIDEBAR'; // Global properties card is the only one with a fixed Id

exports.RIGHT_SIDEBAR = RIGHT_SIDEBAR;
var GLOBAL_PROPERTIES_CARD_ID = '0'; // Client-side cardType for global properties card

exports.GLOBAL_PROPERTIES_CARD_ID = GLOBAL_PROPERTIES_CARD_ID;
var GLOBAL_PROPERTIES_CARD_TYPE = 'GLOBAL_PROPERTIES';
exports.GLOBAL_PROPERTIES_CARD_TYPE = GLOBAL_PROPERTIES_CARD_TYPE;
var PROPERTIES_CARD_TYPE = 'PROPERTIES';
exports.PROPERTIES_CARD_TYPE = PROPERTIES_CARD_TYPE;